export default __webpack_public_path__ + "static/media/home-consulting-tab-img-02.aad552af.jpg";